export default __webpack_public_path__ + "static/media/jangwon_nft_2.d835fcc3.svg";